import MuiBackdrop, { BackdropProps } from "@mui/material/Backdrop";

const Backdrop = ({ ...props }: BackdropProps) => {
    return (
        <MuiBackdrop
            {...props}
            sx={{
                zIndex: "9999",
                backgroundColor: "rgba(37, 42, 49, 0.5)"
            }}
        />
    );
};

export default Backdrop;
